@let user = userService.user | async;

<p>User Team: {{ user.userTeam?.name }}</p>
<p>Time Zone: <p-select size="small"
                        class="btn-xs"
                        optionLabel="shortName"
                        [autofocus]="false"
                        [options]="timezones | async"
                        (onChange)="setTimezone($event.value)"
                        [ngModel]="user.timeZone"/>
</p>
